import Vue from 'vue'
import Router from 'vue-router'
import Inicio from '@/components/Inicio'
import Estoque from '@/components/Estoque'
import Recepcao from '@/components/Recepcao'
import Configuracoes from '@/components/Configuracoes'
import Dashboard from '@/components/Dashboard'
import Login from '@/components/Login'
import SemPermissao from '@/components/SemPermissao'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login,
      beforeEnter: function (to, from, next) {
        if (!(localStorage.getItem('Usuario') !== null)) {
          next()
        } else {
          next({
            path: '/agenda'
          })
        }
      }
    },
    {
      path: '/agenda',
      name: 'Inicio',
      component: Inicio,
      beforeEnter: function (to, from, next) {
        if (!localStorage.getItem('Usuario') !== null) {
          next()
        } else {
          next({
            path: '/login'
          })
        }
      }
    },
    {
      path: '/recepcao',
      name: 'Recepcao',
      component: Recepcao,
      beforeEnter: function (to, from, next) {
        if (JSON.parse(localStorage.getItem('Usuario')).Recepcao === 'OK') {
          next()
        } else {
          next({
            path: '/permissao'
          })
        }
      }
    },
    {
      path: '/estoque',
      name: 'Estoque',
      component: Estoque,
      beforeEnter: function (to, from, next) {
        if (JSON.parse(localStorage.getItem('Usuario')).Estoque === 'OK') {
          next()
        } else {
          next({
            path: '/permissao'
          })
        }
      }
    },
    {
      path: '/configuracoes',
      name: 'Configuracoes',
      component: Configuracoes,
      beforeEnter: function (to, from, next) {
        if (JSON.parse(localStorage.getItem('Usuario')).Configuracoes === 'OK') {
          next()
        } else {
          next({
            path: '/permissao'
          })
        }
      }
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard,
      beforeEnter: function (to, from, next) {
        if (JSON.parse(localStorage.getItem('Usuario')).Dashboard === 'OK') {
          next()
        } else {
          next({
            path: '/permissao'
          })
        }
      }
    },
    {
      path: '/permissao',
      name: 'SemPermissao',
      component: SemPermissao
    },
    {
      path: '*',
      redirect: '/login'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js